import {Component, forwardRef, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Tag} from "../../interface/tag";
import {Dictionary} from "../../interface/dictionary";
import {TagService} from "../../services/tag.service";
import {DictService} from "../../services/dict.service";
import {PermissionTagsService} from "../../services/permission-tags.service";
import {PermissionsTag} from "../../interface/permissions-tag";
import {first} from "rxjs/operators";
import {MatSelectChange} from "@angular/material/select";
import {ReplaySubject} from "rxjs";

@Component({
  selector: 'app-dict-permission-tags',
  templateUrl: './dict-permission-tags.component.html',
  styleUrls: ['./dict-permission-tags.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => DictPermissionTagsComponent)}
  ]
})

export class DictPermissionTagsComponent implements OnInit, ControlValueAccessor,  OnDestroy, OnChanges {
  @Input() label: string;
  @Input() tagType?: string = null;
  @Input() multiple = false;
  @Input() control: FormControl = null;
  @Input() required = false;
  @Input() noneEntry = false;

  externalControl = true;
  disabled = false;
  items: PermissionsTag[] = [];
  value?: number = null;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private permissionTagsService: PermissionTagsService,
    private dictService: DictService,
    private fb: FormBuilder,
  ) {}

  onChange: any = () => { };
  onTouched: any = () => { };

  ngOnInit(): void {

    this.permissionTagsService.getTagDictSubject()
      .pipe(first())
      .subscribe((items: PermissionsTag[]) => {
        items.forEach((item: PermissionsTag) => {
          if (item.active){
            this.items.push(item);
          }
        })
        this.items.sort((a, b) => {
          return (a.name ).localeCompare(b.name );
        });
      });
    if (this.control === null) {
      this.control = new FormControl('');
      this.externalControl = false;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (this.externalControl) {
      return;
    }

    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    if (this.externalControl) {
      return;
    }

    this.control.setValue(value);
    this.value = value;
  }

  onSelectionChange(e: MatSelectChange): void {
    this.value = e.value;
    this.onChange(this.value);
  }

  clearValue(): void {
    this.control.setValue(this.multiple ? [] : '');
    this.writeValue(this.multiple ? [] : '');
    this.onChange(this.value);
  }

  ngOnChanges(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
